export const SPECIES = ['Arabica', 'Canephora', 'Liberica', 'Excelsa'] as const;
export type Species = (typeof SPECIES)[number];

export const PROCESS_TYPE_PRESETS = ['Washed', 'Honey', 'Natural'] as const;
export type ProcessTypePreset = (typeof PROCESS_TYPE_PRESETS)[number];
export const PROCESS_TYPE_OTHER = 'Other' as const;

export interface ImportRow {
  beanName: string;
  description: string;
  processorName: string;
  species: string;
  variety: string;
  processType: string;
  initialQty: number;
  reorderPoint: number;
  standardCost: number;
}

export interface RowError {
  rowIndex: number;
  field: keyof ImportRow;
  message: string;
}
